function solution() {
  return(
  `
    <div class="solution">
      <div class="solution_container">
        <p class="solution_letter solution_letter1" id="letter1">L</p>
        <p class="solution_letter solution_letter2" id="letter2">a</p>
        <p class="solution_letter solution_letter3" id="letter3">u</p>
        <p class="solution_letter solution_letter4" id="letter4">r</p>
        <p class="solution_letter solution_letter5" id="letter5">e</p>
        <p class="solution_letter solution_letter6" id="letter6">n</p>
        <p class="solution_letter solution_letter7" id="letter7">c</p>
        <p class="solution_letter solution_letter8" id="letter8">e</p>
      </div>
    </div>
  `
  )
}

export default solution;